import { api } from "../../../api";
import { TMSResponseProp, RequestTmsParams } from "../types";

export async function getTmsListApi(
  params: RequestTmsParams,
): Promise<TMSResponseProp> {
  const { data } = await api.get<TMSResponseProp>(`/api/loadings`, {
    params,
  });
  return data;
}

export async function exportTmsApi(
  params?: Partial<RequestTmsParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(`/api/loadings/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}
